import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', loadComponent: () => import('./features/home/home').then((m) => m.Home) },
  {
    path: 'no-encontrado',
    loadComponent: () =>
      import('./core/pages/no-encontrado/no-encontrado').then((m) => m.NoEncontrado),
  },
  { path: '**', redirectTo: 'no-encontrado' },
];
